export default __webpack_public_path__ + "static/media/icon_browsers.ecd2e988.png";